import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { ArrowRight, ExternalLink, Facebook, Instagram, PlayCircle } from "lucide-react";
import FacebookPageEmbed from "../../components/facebook/FacebookPageEmbed";
import "./FacebookUpdatesPage.css";

const FACEBOOK = "https://www.facebook.com/symmachinery";

export default function FacebookUpdatesPage() {
  return (
    <main className="sym-fb-page">
      <Helmet>
        <title>Facebook Updates | SYM Machinery Australia</title>
        <meta name="description" content="SYM Machinery's public Facebook timeline, machinery news, deliveries and announcements, available on our website." />
        <link rel="canonical" href="https://symforklifts.com/facebook-updates" />
      </Helmet>
      <header className="sym-fb-hero">
        <div className="sym-fb-wrap">
          <span className="sym-fb-eyebrow"><Facebook size={17}/> SYM MACHINERY SOCIAL UPDATES</span>
          <h1>Latest <span>Facebook Updates</span></h1>
          <p>See machine arrivals, demonstrations, deliveries and announcements from SYM Machinery, right here on our website.</p>
          <nav className="sym-fb-hero-links" aria-label="Social update pages">
            <a href={FACEBOOK} target="_blank" rel="noopener noreferrer"><Facebook size={18}/> Official Facebook Page <ExternalLink size={16}/></a>
            <Link to="/instagram-updates"><Instagram size={18}/> Instagram Updates <ArrowRight size={16}/></Link>
          </nav>
        </div>
      </header>
      <section className="sym-fb-main sym-fb-wrap" aria-labelledby="sym-fb-title">
        <div className="sym-fb-intro">
          <div>
            <span className="sym-fb-kicker">OFFICIAL FACEBOOK PAGE</span>
            <h2 id="sym-fb-title">@symmachinery</h2>
            <p>Browse the public Facebook timeline below. Posts update according to Facebook's own feed and availability.</p>
          </div>
          <span className="sym-fb-label"><Facebook size={16}/> Public page timeline</span>
        </div>
        <div className="sym-fb-display">
          <aside className="sym-fb-aside">
            <div className="sym-fb-avatar"><Facebook size={34}/></div>
            <h3>SYM Machinery</h3>
            <p>Australian family-owned machinery supplier, showcasing 4x4 forklifts, mini excavators and machinery in action.</p>
            <div className="sym-fb-points">
              <p><PlayCircle size={19}/> Machine demonstrations and walkarounds</p>
              <p><Facebook size={19}/> Latest public Facebook posts</p>
              <p><Instagram size={19}/> Reels and Instagram updates</p>
            </div>
            <Link to="/machines" className="sym-fb-browse">Explore our machines <ArrowRight size={18}/></Link>
            <a className="sym-fb-visit" href={FACEBOOK} target="_blank" rel="noopener noreferrer">Visit official Facebook page <ExternalLink size={15}/></a>
          </aside>
          <div className="sym-fb-feed-column">
            <FacebookPageEmbed />
            <p className="sym-fb-disclaimer">This is Facebook's official Page Plugin. Facebook controls the feed layout, available posts, and links inside the embedded timeline. Some browsers may restrict this preview.</p>
          </div>
        </div>
      </section>
      <section className="sym-fb-bottom sym-fb-wrap">
        <div><h2>Explore more from SYM Machinery</h2><p>See additional reels and recent updates, or browse available machines.</p></div>
        <div><Link to="/instagram-updates"><Instagram size={17}/> Instagram Updates</Link><Link to="/machines">Browse Machines <ArrowRight size={17}/></Link></div>
      </section>
    </main>
  );
}
